
import { useNavigate } from 'react-router-dom';
import { allBlogArticles } from '../../../mocks/blogArticles';

const BlogPreview = () => {
  const navigate = useNavigate();

  // Safely get the featured article; handle empty array case
  const featured = allBlogArticles.filter((a) => a.featured).slice(0, 1)[0] ?? null;

  // Exclude the featured article from recent list; also guard against undefined featured
  const recent = allBlogArticles
    .filter((a) => a.id !== featured?.id)
    .slice(0, 4);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
              <strong>Latest Tax Tips &amp; Salary Guides</strong>
            </h2>
            <p className="text-gray-500">
              Expert strategies to maximize your take-home pay in every city
            </p>
          </div>
          <a
            href="/blog"
            onClick={(e) => {
              e.preventDefault();
              navigate('/blog');
            }}
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            View All Articles <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Featured Article */}
          {featured && (
            <article
              onClick={() => navigate(`/blog/${featured.slug}`)}
              className="group relative rounded-2xl overflow-hidden cursor-pointer h-[480px]"
            >
              <div className="absolute inset-0">
                <img
                  src={featured.image}
                  alt={`${featured.title} - ${featured.city} tax guide`}
                  title={`${featured.city} tax tips and strategies`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  width="800"
                  height="480"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/30 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="inline-block px-3 py-1 bg-teal-500 text-white text-xs font-semibold rounded-full mb-3 whitespace-nowrap">
                  {featured.category}
                </span>
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-teal-300 transition-colors leading-tight">
                  {featured.title}
                </h3>
                <p className="text-gray-300 text-sm mb-4 line-clamp-2">{featured.excerpt}</p>
                <div className="flex items-center gap-3 text-sm text-gray-400">
                  <span>{featured.author}</span>
                  <span>&middot;</span>
                  <span>{featured.readTime}</span>
                </div>
              </div>
            </article>
          )}

          {/* Recent Articles Grid */}
          <div className="grid grid-cols-1 gap-4">
            {recent.map((article) => (
              <article
                key={article.id}
                onClick={() => navigate(`/blog/${article.slug}`)}
                className="group flex gap-4 p-4 bg-gray-50 hover:bg-teal-50 rounded-xl transition-all cursor-pointer hover:shadow-sm"
              >
                <div className="w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.image}
                    alt={`${article.title} - tax tips`}
                    title={`${article.city} tax guide`}
                    className="w-full h-full object-cover object-top"
                    width="96"
                    height="96"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-medium text-teal-600">{article.category}</span>
                    <span className="text-xs text-gray-400">&middot;</span>
                    <span className="text-xs text-gray-400">{article.city}</span>
                  </div>
                  <h3 className="text-sm font-bold text-gray-900 group-hover:text-teal-700 transition-colors line-clamp-2 leading-snug mb-1">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <span>{article.author}</span>
                    <span>&middot;</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center lg:hidden">
          <a
            href="/blog"
            onClick={(e) => {
              e.preventDefault();
              navigate('/blog');
            }}
            className="inline-flex items-center gap-2 text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Articles <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
